
const Footer = () => {
  return (
    <footer className=" pt-5 mx-auto">
      <div className="w-10/12   mx-auto gap-4">
        <div className="font-sans  text-[20px] text-center">
          <p className="font-bold ">rvkofficial1@gmail.com</p>
          <p className="m-3">&copy;2024 All Rights reserved</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;